module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-tired.e4956dcc.png";